import React from 'react';
import { Alert, Button, Modal, Space } from 'antd';
import dayjs from 'dayjs';
import { WEEKDAY_LABELS } from './weekUtil';

export default function ConfirmedBanner({ confirmed, onChangeClick, onCancel }) {
  if (!confirmed) return null;

  const d = dayjs(confirmed.date);
  const time = confirmed.time.slice(0, 5);

  const handleCancel = () => {
    Modal.confirm({
      title: '레이드 확정 취소',
      content: `${d.format('YYYY-MM-DD')}(${WEEKDAY_LABELS[d.day()]}) ${time} 확정을 취소할까요? 예약된 알림도 함께 취소됩니다.`,
      okText: '취소하기',
      okButtonProps: { danger: true },
      cancelText: '닫기',
      onOk: onCancel,
    });
  };

  return (
    <Alert
      type="success"
      showIcon
      style={{ marginBottom: 16 }}
      message={`이번 주 레이드: ${d.format('YYYY-MM-DD')}(${WEEKDAY_LABELS[d.day()]}) ${time}`}
      action={
        <Space>
          <Button size="small" onClick={onChangeClick}>변경</Button>
          <Button size="small" danger onClick={handleCancel}>취소</Button>
        </Space>
      }
    />
  );
}
